import { SearchResponse, type RecentRef } from '@myrewards/contracts';
import { request } from './client';

/** Search & jump (APP-022): the people and awards this person may already see. */
export function searchPeopleAndAwards(q: string, signal: AbortSignal): Promise<SearchResponse> {
  return request(`/api/v1/search?q=${encodeURIComponent(q.trim())}`, {
    schema: SearchResponse,
    signal,
  });
}

/**
 * Recent (SHELL1, APP-085): which of these people and awards this person may still open, with
 * today's names and stages. Anything missing from the answer is no longer theirs to open.
 */
export function recheckRecent(
  refs: readonly RecentRef[],
  signal: AbortSignal,
): Promise<SearchResponse> {
  return request(`/api/v1/search/recent?refs=${encodeURIComponent(refs.join(','))}`, {
    schema: SearchResponse,
    signal,
  });
}
